import { render, staticRenderFns } from "./addProductTask.vue?vue&type=template&id=7a54bd18&scoped=true&"
import script from "./addProductTask.vue?vue&type=script&lang=js&"
export * from "./addProductTask.vue?vue&type=script&lang=js&"
import style0 from "./addProductTask.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addProductTask.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./addProductTask.vue?vue&type=style&index=2&id=7a54bd18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a54bd18",
  null
  
)

export default component.exports